import { render, staticRenderFns } from "./batchnotification_list.vue?vue&type=template&id=c122b97c&scoped=true&"
import script from "./batchnotification_list.vue?vue&type=script&lang=js&"
export * from "./batchnotification_list.vue?vue&type=script&lang=js&"
import style0 from "./batchnotification_list.vue?vue&type=style&index=0&id=c122b97c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c122b97c",
  null
  
)

export default component.exports